import { render, staticRenderFns } from "./tab_list.vue?vue&type=template&id=d3020064&scoped=true&"
import script from "./tab_list.vue?vue&type=script&lang=js&"
export * from "./tab_list.vue?vue&type=script&lang=js&"
import style0 from "./tab_list.vue?vue&type=style&index=0&id=d3020064&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3020064",
  null
  
)

export default component.exports